// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { BaseMapInfo } from './BaseMapInfo';
import { VisibleTiles } from './VisibleTiles';
import { TileData } from './TileData';

export class LoadBaseMapTileRequest implements ILoadBaseMapTileRequest {
    baseMapInfo!: BaseMapInfo;
    tiles!: TileData[];

    constructor(data?: ILoadBaseMapTileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseMapInfo = _data["baseMapInfo"] ? BaseMapInfo.fromJS(_data["baseMapInfo"]) : <any>undefined;
            if (Array.isArray(_data["tiles"])) {
                this.tiles = [] as any;
                for (let item of _data["tiles"])
                    this.tiles!.push(TileData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoadBaseMapTileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoadBaseMapTileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseMapInfo"] = this.baseMapInfo ? this.baseMapInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.tiles)) {
            data["tiles"] = [];
            for (let item of this.tiles)
                data["tiles"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ILoadBaseMapTileRequest {
    baseMapInfo: BaseMapInfo;
    tiles: TileData[];
}